import classNames from 'classnames'
import Image from 'next/image'
import { StaticImageData } from 'next/image'

import { config } from '@/components/Ad/Ad'
import OutboundLink from '@/components/OutboundLink/OutboundLink'

import styles from './GatherersTavernAd.module.scss'

type GatherersTavernConfigEntryType = {
  banner: string
  poster: string
}

type GatherersTavernConfigType = {
  [key: string]: GatherersTavernConfigEntryType
}

/* eslint-disable sort/object-properties */
const gatherersTavernConfig: GatherersTavernConfigType = {
  // Dragons of Tarkir
  'betor-ancestors-voice': { banner: 'gatherersTavernBannerBetor', poster: 'gatherersTavernPosterBetor' },
  'betor-kin-to-all': { banner: 'gatherersTavernBannerBetor', poster: 'gatherersTavernPosterBetor' },
  'neriv-crackling-vanguard': { banner: 'gatherersTavernBannerNeriv', poster: 'gatherersTavernPosterNeriv' },
  'neriv-heart-of-the-storm': { banner: 'gatherersTavernBannerNeriv', poster: 'gatherersTavernPosterNeriv' },
  'shiko-and-narset-unified': { banner: 'gatherersTavernBannerShiko', poster: 'gatherersTavernPosterShiko' },
  'shiko-paragon-of-the-way': { banner: 'gatherersTavernBannerShiko', poster: 'gatherersTavernPosterShiko' },
  'teval-arbiter-of-virtue': { banner: 'gatherersTavernBannerTeval', poster: 'gatherersTavernPosterTeval' },
  'teval-the-balanced-scale': { banner: 'gatherersTavernBannerTeval', poster: 'gatherersTavernPosterTeval' },
  'ureni-the-song-unending': { banner: 'gatherersTavernBannerUreni', poster: 'gatherersTavernPosterUreni' },
  'ureni-of-the-unwritten': { banner: 'gatherersTavernBannerUreni', poster: 'gatherersTavernPosterUreni' },
  // Avatar - Momo
  'momo-friendly-flier': { banner: 'gatherersTavernBannerMomo', poster: 'gatherersTavernPosterMomo' },
  'momo-playful-pet': { banner: 'gatherersTavernBannerMomo', poster: 'gatherersTavernPosterMomo' },
  'momo-rambunctious-rascal': { banner: 'gatherersTavernBannerMomo', poster: 'gatherersTavernPosterMomo' },
  // Avatar - Appa
  'appa-aangs-companion': { banner: 'gatherersTavernBannerAppa', poster: 'gatherersTavernPosterAppa' },
  'appa-loyal-sky-bison': { banner: 'gatherersTavernBannerAppa', poster: 'gatherersTavernPosterAppa' },
  'appa-steadfast-guardian': { banner: 'gatherersTavernBannerAppa', poster: 'gatherersTavernPosterAppa' },
  'appa-the-vigilant': { banner: 'gatherersTavernBannerAppa', poster: 'gatherersTavernPosterAppa' },
  // Avatar - Air
  'aang-a-lot-to-learn': { banner: 'gatherersTavernBannerAtlaAir', poster: 'gatherersTavernPosterAtlaAir' },
  'aang-air-nomad': { banner: 'gatherersTavernBannerAtlaAir', poster: 'gatherersTavernPosterAtlaAir' },
  'aang-airbending-master': { banner: 'gatherersTavernBannerAtlaAir', poster: 'gatherersTavernPosterAtlaAir' },
  'aang-at-the-crossroads': { banner: 'gatherersTavernBannerAtlaAir', poster: 'gatherersTavernPosterAtlaAir' },
  'aang-swift-savior': { banner: 'gatherersTavernBannerAtlaAir', poster: 'gatherersTavernPosterAtlaAir' },
  'aang-the-last-airbender': { banner: 'gatherersTavernBannerAtlaAir', poster: 'gatherersTavernPosterAtlaAir' },
  'avatar-aang': { banner: 'gatherersTavernBannerAtlaAir', poster: 'gatherersTavernPosterAtlaAir' },
  'monk-gyatso': { banner: 'gatherersTavernBannerAtlaAir', poster: 'gatherersTavernPosterAtlaAir' },
  // Avatar - Earth
  'bumi-eclectic-earthbender': { banner: 'gatherersTavernBannerAtlaEarth', poster: 'gatherersTavernPosterAtlaEarth' },
  'bumi-king-of-three-trials': { banner: 'gatherersTavernBannerAtlaEarth', poster: 'gatherersTavernPosterAtlaEarth' },
  'bumi-unleashed': { banner: 'gatherersTavernBannerAtlaEarth', poster: 'gatherersTavernPosterAtlaEarth' },
  'toph-earthbending-master': { banner: 'gatherersTavernBannerAtlaEarth', poster: 'gatherersTavernPosterAtlaEarth' },
  'toph-greatest-earthbender': { banner: 'gatherersTavernBannerAtlaEarth', poster: 'gatherersTavernPosterAtlaEarth' },
  'toph-hardheaded-teacher': { banner: 'gatherersTavernBannerAtlaEarth', poster: 'gatherersTavernPosterAtlaEarth' },
  'toph-the-blind-bandit': { banner: 'gatherersTavernBannerAtlaEarth', poster: 'gatherersTavernPosterAtlaEarth' },
  'toph-the-first-metalbender': { banner: 'gatherersTavernBannerAtlaEarth', poster: 'gatherersTavernPosterAtlaEarth' },
  // Avatar - Fire
  'iroh-dragon-of-the-west': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'iroh-firebending-instructor': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'iroh-grand-lotus': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'iroh-tea-master': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'uncle-iroh': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'zuko-avatar-hunter': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'zuko-conflicted': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'zuko-exiled-prince': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'zuko-firebending-master': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'zuko-redeemed': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  'zuko-seeking-honor': { banner: 'gatherersTavernBannerAtlaFire', poster: 'gatherersTavernPosterAtlaFire' },
  // Avatar - Water
  'katara-bending-prodigy': { banner: 'gatherersTavernBannerAtlaWater', poster: 'gatherersTavernPosterAtlaWater' },
  'katara-heroic-healer': { banner: 'gatherersTavernBannerAtlaWater', poster: 'gatherersTavernPosterAtlaWater' },
  'katara-seeking-revenge': { banner: 'gatherersTavernBannerAtlaWater', poster: 'gatherersTavernPosterAtlaWater' },
  'katara-the-fearless': { banner: 'gatherersTavernBannerAtlaWater', poster: 'gatherersTavernPosterAtlaWater' },
  'katara-water-tribes-hope': { banner: 'gatherersTavernBannerAtlaWater', poster: 'gatherersTavernPosterAtlaWater' },
  'katara-waterbending-master': { banner: 'gatherersTavernBannerAtlaWater', poster: 'gatherersTavernPosterAtlaWater' },
  'princess-yue': { banner: 'gatherersTavernBannerAtlaWater', poster: 'gatherersTavernPosterAtlaWater' },
  'yue-the-moon-spirit': { banner: 'gatherersTavernBannerAtlaWater', poster: 'gatherersTavernPosterAtlaWater' },
}
/* eslint-enable sort/object-properties */

const dimensions = {
  banner: { height: 90, width: 728 },
  poster: { height: 225, width: 400 },
}

const findGatherersTavernSlug = (slugs: string[]): keyof typeof gatherersTavernConfig | null =>
  slugs.find((slug) => slug in gatherersTavernConfig) ?? null

type Props = {
  className?: string
  slug: keyof typeof gatherersTavernConfig
  variant: keyof GatherersTavernConfigEntryType
}

const GatherersTavernAd = ({ className, slug, variant }: Props) => {
  const adConfig = gatherersTavernConfig[slug]

  if (!adConfig) return null

  const { alt, src, url } = config[adConfig[variant]]

  return (
    <div className={classNames(styles.container, className, styles[variant])}>
      <OutboundLink url={url as string}>
        <Image
          alt={alt}
          className={styles.image}
          height={dimensions[variant].height}
          src={src as StaticImageData}
          width={dimensions[variant].width}
        />
      </OutboundLink>
    </div>
  )
}

export { findGatherersTavernSlug }
export default GatherersTavernAd
